export const LoginRoutesConst = {
  DashboardD: "Dashboard-D",
  DashboardA: "Dashboard-A",
  PatientD: "Patient-D",
  PatientA: "Patient-A",
  UserProfile: "UserProfile",
  UserList: "UserList",
  UserAdd: "UserAdd",
  UserLogout: "UserLogout",
  Retention: "Retention",
  ResourceManagement: "ResourceManagement",
  AuditLog: "AuditLog",
  AudioStudio: "AudioStudio",
} as const;
